<template>
  <div class="courses-course-card card">
    <div class="card-body d-flex flex-column">
      <div
        class="course-cover mb-3"
        :style="`background-image: url(${course.cover})`"
      />

      <template v-if="!blocked">
        <div class="d-flex align-items-center">
          <div class="flex-fill">
            <b-progress
              :value="course.progress"
              :max="100"
              height="5px"
            ></b-progress>
          </div>
          <small class="text-secondary ml-2">{{ progress }}%</small>
        </div>
        <h4 class="mb-5 text-uppercase font-weight-bold text-dark">
          {{ course.title }}
        </h4>
        <!-- <h4 class="mb-5">{{ course.title }}</h4> -->

        <div class="flex-fill"></div>

        <div class="d-flex justify-content-end">
          <router-link
            class="btn btn-primary font-weight-bold px-4 stretched-link"
            :to="{ name: 'course-lessons', params: { ...course } }"
          >
            Acessar
            <i class="icon-arrow-right ml-2"></i>
          </router-link>
        </div>
      </template>

      <template v-if="blocked">
        <h4 class="mb-2 text-uppercase font-weight-bold text-dark">
          {{ course.title }}
        </h4>
        <p class="mb-5">
          <s v-if="course.discount">R$ {{ normalPrice }}</s>
          R$ {{ finalPrice }}
        </p>

        <div class="flex-fill"></div>

        <div class="d-flex justify-content-end">
          <router-link
            :to="{ name: 'course-details', params: { ...course } }"
            class="btn btn-dark font-weight-bold px-4 stretched-link"
          >
            Comprar
          </router-link>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { formatMoney } from "@/functions/helpers.js";
import get from "lodash/get";

export default {
  props: {
    course: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    blocked() {
      // check if is academia cof page
      // if (location.pathname === "/academicos") {
      //   // releases free courses for user
      //   return !get(this.course, "product.is_free");
      // }
      if (get(this.course, "product.is_free")) {
        return false;
      }
      // check if user has the course for release
      return !this.$user.myCourses[this.course.id];
    },
    progress() {
      return parseInt(this.course.progress);
    },
    normalPrice() {
      return formatMoney(parseFloat(get(this.course, "product.price_card"), 0));
    },
    finalPrice() {
      return formatMoney(
        parseFloat(get(this.course, "product.price_card", 0)) -
          parseFloat(get(this.course, "product.discount", 0) || 0)
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.courses-course-card {
  .card-body {
    padding: 16px 16px 24px;

    p {
      font-size: 14px;
      line-height: 21px;
      color: #979797;
    }

    h4 {
      font-weight: bold;
      font-size: 18px;
      line-height: 28px;
      color: #272d32;
    }

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      color: white !important;
    }
  }
}
</style>
